import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as InfoIcon } from '../../images/info-icon.svg';

import css from './promoteVipPopupInfo.module.sass';

export const PromoteVipPopupInfo = () => {
  const { t } = useTranslation('app');

  return (
    <div className={css.root}>
      <InfoIcon className={css.icon} />
      <p className={css.info}>{t('promoteVipPopup.info')}</p>
    </div>
  );
};
